package com.wintermar.inspection

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String
import migrations.TemplateOptionTable

public class TemplateOptionTableQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getAnswerOptions(mapper: (
    id: String,
    orderPosition: Long,
    label: String,
    answerType: String,
  ) -> T): Query<T> = Query(-483_677_517, arrayOf("TemplateOptionTable"), driver, "TemplateOptionTable.sq", "getAnswerOptions", "SELECT TemplateOptionTable.id, TemplateOptionTable.orderPosition, TemplateOptionTable.label, TemplateOptionTable.answerType FROM TemplateOptionTable ORDER BY orderPosition ASC") { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!
    )
  }

  public fun getAnswerOptions(): Query<TemplateOptionTable> = getAnswerOptions(::TemplateOptionTable)

  /**
   * @return The number of rows updated.
   */
  public fun insertAnswerOption(
    id: String,
    orderPosition: Long,
    label: String,
    answerType: String,
  ): QueryResult<Long> {
    val result = driver.execute(202_449_493, """
        |INSERT INTO TemplateOptionTable(id, orderPosition, label, answerType)
        |VALUES (?, ?, ?, ?)
        |ON CONFLICT(id) DO UPDATE SET
        |   orderPosition=excluded.orderPosition,
        |   label=excluded.label,
        |   answerType=excluded.answerType
        """.trimMargin(), 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindLong(parameterIndex++, orderPosition)
          bindString(parameterIndex++, label)
          bindString(parameterIndex++, answerType)
        }
    notifyQueries(202_449_493) { emit ->
      emit("TemplateOptionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertReplaceAnswerOption(
    id: String,
    orderPosition: Long,
    label: String,
    answerType: String,
  ): QueryResult<Long> {
    val result = driver.execute(-2_027_971_611, """
        |INSERT OR REPLACE INTO TemplateOptionTable(id, orderPosition, label, answerType)
        |VALUES (?, ?, ?, ?)
        """.trimMargin(), 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindLong(parameterIndex++, orderPosition)
          bindString(parameterIndex++, label)
          bindString(parameterIndex++, answerType)
        }
    notifyQueries(-2_027_971_611) { emit ->
      emit("TemplateOptionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteAllAnswerOptions(): QueryResult<Long> {
    val result = driver.execute(813_413_203, """DELETE FROM TemplateOptionTable""", 0)
    notifyQueries(813_413_203) { emit ->
      emit("TemplateOptionTable")
    }
    return result
  }
}
